import React, {useState, useEffect } from 'react'
import { Stack, Typography, Button, Chip, IconButton, Skeleton, Paper, Table, Tooltip,useTheme, useMediaQuery, TableBody, TableContainer, TableHead, Box, Menu, MenuItem,Accordion ,AccordionActions,AccordionSummary,AccordionDetails, Divider, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle  } from '@mui/material';
import MainLayout from '../components/MainLayout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ReactComponent as DollarSymbolIcon } from '../img/DollarSymbol.svg';
import { ReactComponent as AddButtonIcon } from '../img/AddButtonIcon.svg';
import { ReactComponent as WithdrawIcon } from '../img/withdrawMinus.svg';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as DotsIcon } from '../img/DotsIcon.svg'
import { StyledTableRow, StyledTableCell } from "../Theme"
import { colors } from '../Theme/tokens';
import Chart from 'react-apexcharts';
import dayjs from 'dayjs';
import { ApiService } from '../API/AxiosInstance';
import { useNavigate } from 'react-router-dom';
import Freecurrencyapi from '@everapi/freecurrencyapi-js';
import InfiniteIcon from '../img/products/infinite.png';
import { ReactComponent as WithdrawMobileSvg } from '../img/withdrawMobileSvg.svg'
import { ReactComponent as DepositMobileSvg } from '../img/depositMobileSvg.svg'
import { MdAdd } from "react-icons/md";
import { FaMinus } from "react-icons/fa6";
import EmptyChart from './EmptyChart';
import './chart.css';
import OnboardingStatusHook from './customhook/onboardingStatus';
import BouncingDotsLoader from '../utils/BouncingDotsLoader';
import { ShimmerSkeleton } from '../utils/SkimmerSkeleton';
import { removeMinus } from '../utils/validation';
import FeatureSoon from '../components/FeatureSoon';
import { captureException } from "@sentry/react";
import BankDetailsModal from './Transactions/BankDetailsModal';
import { calculatePercentageAmount } from '../utils/validation';
import TooltipContent from '../components/ToolTipContent';
import { ReactComponent as IdleCashToolTip } from '../img/idleCashToolTip.svg';


export default function Portfolio() {
  const theme = useTheme();
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [chartDatas, setChartData] = useState([])
    const [metrics, setMetrics] = useState({netInvestedValue:0,percentProfitLoss:0})
    const [returnAmount, setReturnAmount] = useState(0)
    const [anchorEl, setAnchorEl] = useState(null);
    const [currency, setCurrency] = useState(localStorage.getItem('portfolio_currentCurrency') ? localStorage.getItem('portfolio_currentCurrency') : 'SGD');
    const [prices, setPrices] = useState([])
    const [duration, setDuration] = useState('1 Year')
    const [productEl, setProductEl] = useState(null);
    const [graphData, setGraphData] = useState({})
    const [totalAmount, setTotalAmount] = useState(0)
    const [allProducts, setAllProducts] = useState([])
    const [transactionProducts, setTransactionProducts] = useState([])
    const [subscribedProducts, setSubscribedProducts] = useState([])
    const [selectedProductId, setSelectedProductId] = useState(null);
    const freecurrencyapi = new Freecurrencyapi('fca_live_vwfRDGk3Sez0uggsKls6UuhMjuhi3KRiaM3zBljh');
    const [currentUSDPrice, setCurrentUSDPrice] = useState(0)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [expanded, setExpanded] = useState(false);
    const [activePortfolio, setActivePortfolio] = useState([])
    const [totalAmountLoading, setTotalAmountLoading] = useState(false)
    const matches = useMediaQuery('(min-width:1025px) and (max-width:1199px)'); //For enable tooltip for product names
    const { onboardingStatusText, apiLoading, error } = OnboardingStatusHook(`${process.env.REACT_APP_BASE_URL}users/${userId}/onboarding/status`, {headers:{'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : null}`}});
    const [contactModal, setContactModal] = useState(false)
    const [transactionType, setTransactionType] = useState('')
    const [bankDetailModal, setBankDetailModal] = useState(false)
    const [idleCash,setIdleCash] = useState({value: 0.00, isInitialized: false})
    const profitLoseAmount = calculatePercentageAmount(metrics.netInvestedValue, metrics.percentProfitLoss)
    const parsedPercentage = parseFloat(metrics?.netInvestedValue);
    const [capitalToolTipOpen, setCapitalToolTipOpen] = useState(false);
    const [idleCashToolTipOpen, setIdleCashToolTipOpen] = useState(false);

      const tooltipText = !onboardingStatusText
  ? "Please complete the onboarding to view your idle cash balance."
  : !idleCash.isInitialized
    ? "Idle cash initialization has not completed."
    : "This figure represents the current usable balance available to either buy products or make a withdrawal.";

    const tooltipTextTitle = !onboardingStatusText
  ? "Onboard today to unlock"
  : !idleCash.isInitialized
    ? "Available Idle Cash"
    : "Available Idle Cash";

    useEffect(() => {
      if(userId)  getIdleCash()
    },[userId])

    const getIdleCash =async () => {
      try {
        const response = await ApiService().get(`users/${userId}/idle-cash`)
        console.log("idlecash ",response)
        setIdleCash(prev=>({...prev, value: response?.data?.idleCashPortfolio?.amount, isInitialized:true}))
      } catch(error) {
        setIdleCash(prev=>({...prev, value: 0.00, isInitialized:false}))
      }
    }

    const showBankDetails = () => {
      setBankDetailModal(true)
    }


    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

    const getUSDCurrecyValue = () => {
      freecurrencyapi.latest({
        base_currency: 'SGD',
        currencies: 'USD'
        }).then(response => {
            if(response?.data) {
              setCurrentUSDPrice(response?.data?.USD)
              getPrices(response?.data?.USD)
            }
        }).catch(error => {
          return false
        })
    }

    useEffect(() => {
      if(localStorage.getItem('portfolio_currentCurrency')) {
        localStorage.setItem('portfolio_currentCurrency', currency)
        if(localStorage.getItem('portfolio_currentCurrency') == "USD") {
          getUSDCurrecyValue()
        }
      } else {
        localStorage.setItem('portfolio_currentCurrency', 'SGD')
      }
  
    },[currency])

    const handleDuration = (value) => {
        setDuration(value)
    }
    const getChartData = async () => {
        try {
          const response = await ApiService().get(`users/${userId}/timeseries`)
          if(response?.data) {
            if(response?.data?.data?.length > 0) {
              setChartData(response.data.data)
            }
          }
          
        } catch (error) {
          setLoading(false)
          captureException(error)
        }
      };

      const getActivePortfolio = async () => {
        try {
          const response = await ApiService().get(`portfolios?userId=${userId}&isActive=true`)
          if(response?.status == 200) {
            if(response?.data?.portfolios?.length > 0) {
              setActivePortfolio(response?.data?.portfolios)
            } else {
              setActivePortfolio([])
            }
            
            setLoading(false)
          }
          
        } catch (error) {
          setLoading(false)
          captureException(error)
        }
      };
    
      const getMetrics = async () => {
        setTotalAmountLoading(true)
        try {
          const response = await ApiService().get(`users/${userId}/portfolio-metrics?isActiveOnly=true`)
          if(response?.data) {
            if(response?.data) {
              calculateTotalAmount(response?.data)
              setMetrics({netInvestedValue: response.data.metrics.netInvestedValue, percentProfitLoss: response.data.metrics.percentProfitLoss})
            }
            setLoading(false)
          }
          
        } catch (error) {
          setLoading(false)
          setTotalAmountLoading(false)
          captureException(error)
        }
      };

    const getSubscribedProducts = async() => {
      try {
        const response =  await ApiService().get(`users/${userId}/products/product-portfolio-metrics`)
        if(response?.data?.products?.length > 0) {
          setTransactionProducts(response.data.products)
        }
  
      } catch(error) {
        setLoading(false)
        captureException(error)
      }
    }

    const getAllProducts = async() => {
      try {
        const response =  await ApiService().get('products?page=0&limit=25')
        if(response?.data?.products?.length > 0) {
          setAllProducts(response?.data?.products?.filter((product) => product?.isActive == true))
      }
  
      } catch(error) {
      setLoading(false)
      captureException(error)
      }
    }

    useEffect(() => {
      if (allProducts?.length > 0 && transactionProducts?.length > 0 && activePortfolio?.length >0) {
        const filteredProducts = allProducts?.filter(productItem => transactionProducts.some(transaction => transaction.id === productItem.id))
        const iconUrls = filteredProducts?.map(item => {
            const iconTag = item.tags.find(tag => tag.hasOwnProperty('iconUrl'));
          return {
            id: item.id,
            iconUrl: iconTag && iconTag.iconUrl ? iconTag.iconUrl : "https://assets.tradetogether.app/products/BitcoinAdvantage.svg", 
          };
        });
        const onlyActiveProducts = transactionProducts?.filter(product =>
        iconUrls?.some(availableProduct => availableProduct.id === product.id));
        
        const updatedTransactionProducts = onlyActiveProducts?.map(transaction => {
          const matchingIcon = iconUrls?.find(iconItem => iconItem?.id === transaction?.id);
          return {
            ...transaction,
            iconUrl: matchingIcon?.iconUrl,
          };
        });        

        const activatedPortfolios = updatedTransactionProducts?.filter(product => activePortfolio?.some(portfolio => portfolio?.productId === product?.id))
        setSubscribedProducts(activatedPortfolios)
      }
  }, [allProducts, transactionProducts, activePortfolio]);

    useEffect(() => {
        setLoading(true)
        getChartData()
        getActivePortfolio()
        getMetrics()
        getSubscribedProducts()
        getAllProducts()

    },[userId])

    const calculateTotalAmount =  (data) => {
      const increasedAmount = (parseFloat(data.metrics.percentProfitLoss) / 100) * parseFloat(data.metrics.netInvestedValue);
      const calculatedAmount = parseFloat(data.metrics.netInvestedValue) + increasedAmount;
      const finalAmount = formatWithTwoDecimalRounding(calculatedAmount)
      setTotalAmountLoading(false)
      setTotalAmount(parseFloat(finalAmount));
      const profitOrLossAmount  = finalAmount- parseFloat(data.metrics.netInvestedValue)
      console.log("profitOrLossAmount ",profitOrLossAmount)
      setReturnAmount(profitOrLossAmount)
    }

    const formatWithTwoDecimalRounding = (num) => {
      // const [integerPart, decimalPart] = num.toString().split('.');
      // if (decimalPart && decimalPart.length > 2) {
      //   return `${integerPart}.${decimalPart.slice(0, 2)}`;
      // }
      // return num.toFixed(2);
      return Math.round((num + Number.EPSILON) * 100) / 100
    };

    const resetToFirstDayOfMonth = (data) => {
      return data.map((item) => {
        const newDate = dayjs(item.date).startOf('month').format('YYYY-MM-DD');
        return { ...item, date: newDate }; 
      });
    };
  
    const getLastDayOfMonthData = (data) => {
      return data.reduce((acc, current) => {
        const currentDate = new Date(current.date);
        const yearMonth = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}`;
    
        if (!acc[yearMonth] || new Date(acc[yearMonth].date) < currentDate) {
          acc[yearMonth] = current;
        }
    
        return acc;
      }, {});
    };
    
    const filterData = (data, range) => {
      const singleDateForMonth = Object.values(getLastDayOfMonthData(data))
      const updatedCharty = resetToFirstDayOfMonth(singleDateForMonth);

      if(updatedCharty?.length > 0) {
        const now = dayjs(); 
        // const filtered = data.filter(({ date }) => {
        //   const dataDate = dayjs(date);
        //   if (range === '6 Months') {
        //     return dataDate.isAfter(now.subtract(6, 'month'));
        //   } else if (range === '1 Year') {
        //     return dataDate.isAfter(now.subtract(1, 'year'));
        //   }
        //   return false;
        // });

        const filtered = updatedCharty?.filter(({ date }) => {
          const dataDate = dayjs(date); 
          
          if (range === '6 Months') {
            const sixMonthsAgo = now.subtract(6, 'month'); 
            return dataDate.isAfter(sixMonthsAgo); 
          } else if (range === '1 Year') {
            const oneYearAgo = now.subtract(1, 'year'); 
            return dataDate.isAfter(oneYearAgo); 
          }
        
          return false;
        });
        return filtered;
    } else {
      return []
    }
      };
    
      useEffect(() => {
        if (chartDatas?.length > 0) {
          if(currency == "SGD")  {
            getPrices()
          } else {
            getUSDCurrecyValue()
          }
        }
        return() => {
          localStorage.removeItem('prices')
        }
      
      }, [chartDatas, duration]);

      // const getPrices = (currentPrice) => {
      //   const filtered = filterData(chartDatas, duration);
      //   if(chartDatas?.length >0 && filtered?.length <= 3) {
      //     const formattedData = filtered.map(item => ({
      //       x: item.date, 
      //       y: currentPrice ? parseFloat(sgdToUsd(item.price, 0.76)) : item.price
      //     }));
      //     setPrices(formattedData);
      //     localStorage.setItem('prices',JSON.stringify(formattedData))
      //   } else if(chartDatas?.length > 0) {
      //     const formattedData = filtered?.map(item => ({
      //       x: dayjs(item.date).valueOf(), // Convert to timestamp
      //       y: currentPrice ? parseFloat(sgdToUsd(item.price, 0.76)) : item.price
      //     }));
      //     setPrices(formattedData);
      //     localStorage.setItem('prices',JSON.stringify(formattedData))
      //   }
      //     setLoading(false)
      // }

      const getPrices = (currentPrice) => {
        const filtered = filterData(chartDatas, duration);
        if(chartDatas?.length >0) {
          const formattedData = filtered.map(item => ({
            x: item.date, 
            y: currentPrice ? parseFloat(sgdToUsd(parseFloat(item.price), 0.76)) : parseFloat(item.price)
          }));
          if(formattedData?.length == 1) {
            let oneDate = formattedData[0]?.x
            let dates =  dayjs(oneDate).subtract(1, 'month').format('YYYY-MM-DD')
            formattedData?.unshift({x: dates, y:0})
          }
          setPrices(formattedData);
          localStorage.setItem('prices',JSON.stringify(formattedData))
        } 
        setLoading(false)
      }

      useEffect(() => {
        makeChart()
        },[isMediumScreen])
    
      const sgdToUsd = (sgdPrice, currentUSPrice)=> {
        console.log("currentUSPrice ",typeof currentUSPrice)
          const usdPrice = sgdPrice * parseFloat(currentUSPrice)?.toFixed(2)
          return usdPrice ?  parseFloat(usdPrice) : 0
          
      }

    const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    };

    const handleClose = (value) => {
      if (value) {
        setCurrency(value);
      }
      if(value == 'USD') {
        
        localStorage.setItem('portfolio_currentCurrency','USD')
        getUSDCurrecyValue()
      } else if(value == "SGD") {
        localStorage.setItem('portfolio_currentCurrency','SGD')
        getPrices()
      }
      setAnchorEl(null);
    };

  const handleClickMore = (event, product_id) => {
    setProductEl(event.currentTarget);
    setSelectedProductId(product_id);
  };

  const handleProductMenuClose = () => {
    setProductEl(null);
    setSelectedProductId(null);
  };

  const handleViewProduct = () => {
    navigate(`/Products/productDetails/${selectedProductId}`); 
    handleProductMenuClose();
  };

  const handleUnsubscribe = () => {
    handleProductMenuClose();
  };

const handleContactUs = (type) => {
  setContactModal(true)
  setTransactionType(type)
}

const handleContactUsClose = () => {
  setContactModal(false)
}

const returnPrice = () => {
  if(prices?.length > 0) {
    return prices
  }
}

useEffect(() => {
  if(prices?.length > 0) {
     makeChart()
     
  }
}, [prices]);


const makeChart = () => {
  if (prices?.length > 0) {

    const chartData = {
      options: {
        chart: {
          type: 'area',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false, 
        },
        },
        padding: {
          top: '100px',
          bottom: '100px',
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            style: {
              fontWeight: '600',
              colors: colors.text.disabled2,
            },
            formatter: function (value) {
              return '$ ' + Math.round(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            },
          },
        },
        xaxis: {
          opposite: false,
          type: 'category',
          tickAmount: 3,
          // tickPlacement: 'between',
          labels: {
            format: 'MMM yy',
            formatter: function (value) {
                return dayjs(value).format('MMM YY');
            },
            style: {
              fontWeight: '600',
              colors: colors.text.disabled2,
              paddingLeft:'20px',
            },
        },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip:{
            enabled:false
          }
        },
        colors: [colors.secondary.dark],
        fill: {
          type: 'gradient',
          colors: [colors.secondary.dark],
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        grid: {
          show: true,
          // strokeDashArray: 10,
          // padding: {
          //   left: 20,
          // }
        },
        stroke: {
          width: 2,
          curve: 'smooth', 
        },
        tooltip: {
          enabled: true,
          custom: function({ dataPointIndex}) {
            const localStoragePrices =  localStorage.getItem('prices') ? JSON.parse(localStorage.getItem('prices')) : ""
            const dataPoint = localStoragePrices[dataPointIndex];  // Use prices directly
            const date = dayjs(dataPoint?.x).format('MMM YYYY');
            const price = `$ ${dataPoint?.y.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
    
            return `<div style="background-color: white; padding: 5px 15px 0px; border-radius: 5px; text-align: center;">
                      <p style="font-weight:600;font-family:CeraPro;font-size:13px;letter-spacing:2%;color:${colors.text.primary};">${date}</p>
                      <p style="font-weight:600;font-family:CeraPro;font-size:13px;letter-spacing:2%;color:${colors.text.primary};">${price}</p>
                    </div>`;
          },
        },
      },
      series:[
        {
          data: returnPrice(),
        },
      ],
    };

    setGraphData(chartData);
  } else {
    setGraphData({});
  }
}

const getIconUrl = (productIcon) => {
  return productIcon ? productIcon : "https://assets.tradetogether.app/products/BitcoinAdvantage.svg";
} 

console.log("subscribedProducts ", subscribedProducts)

    return (
        <>
        <FeatureSoon open={contactModal} transactionType={transactionType} handleContactUsClose={handleContactUsClose} />
        <BankDetailsModal bankDetailModal={bankDetailModal} setBankDetailModal={setBankDetailModal} />
            {/* <Box mt={2} sx={{ backgroundColor: colors.background.default, width: '100%', height: 'auto',  maxWidth:"1580px",}}> */}
            <MainLayout>
                <Paper sx={{ backgroundColor: colors.primary.contrastText, padding: { sm: '20px 35px 20px 34px', xs: '20px 5px 20px 5px' }, borderRadius: '20px', height: 'auto',boxShadow: `0px 1px 5px 0px ${colors.border.card}`, }}>
                   <>
                      <Stack sx={{flexDirection:{ md: 'row', xs: 'column'}, marginTop:'0px !important',
                         '@media(max-width:1180px)': {
                          flexDirection:"column"
                        }  
                       }} justifyContent='space-between ' alignItems='center'>
                          <Stack spacing={1} direction='column' sx={{marginTop:'0px !important',width:"100%", display:"flex", textAlign: {xs: 'center', sm: 'start'}, '@media(max-width:1180px)': {
                              textAlign:"center"
                            }    }}>
                              <Box sx={{display:"flex", justifyContent:{xs:"center",lg:"space-between"}, width:"100%"}}>
                                <Typography variant='h2' sx={{color:colors.nav.labelColor, fontWeight:"550", fontSize:{xs:"23px", md:"26.43px", lg:"28.43px" }, textAlign:"center"}}>Current Balance</Typography>
                                <Box sx={{display:{xs:"none",lg:"flex"}, gap:2}}>
                                  <Button onClick={showBankDetails} endIcon={<MdAdd />} sx={{display:{xs:"none",lg:"flex" }, width:"140px"}} variant="contained">Add Deposit</Button>
                                  <Button onClick={()=> handleContactUs('withdrawal')} endIcon={<FaMinus />} sx={{display:{xs:"none",lg:"flex"}, width:"140px"}} variant="outlined">Withdraw </Button>
                                </Box>
                              </Box>
                              {/* <Typography variant='h2' sx={{color:colors.nav.labelColor, fontWeight:"550", fontSize:{xs:"23px", md:"26.43px", lg:"28.43px" }}}>Current Balance</Typography> */}
                               <Stack pt={{ xs: 2, sm: 0 }} rowGap={1} spacing={{ xs: 1, sm: 3 }} sx={{display:"flex", gap:"20px", flexDirection:{ xs: 'column', md: "row"},marginTop:'0px !important','@media(max-width:1180px)': {
                                flexDirection:"column"
                              }  }} alignItems='center' >
                                  {(!loading && !totalAmountLoading) ? <Typography  sx={{fontSize:{xs:"45px",md:"60px"}, display: 'flex', fontWeight:"700", color: colors.text.primary }}><Box componet='span' pr={2} >$</Box>{totalAmount ? currency == "USD" ? sgdToUsd(totalAmount, currentUSDPrice).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : totalAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}</Typography> 
                                  : <BouncingDotsLoader  sx={{width:"40px !important", height:"40px !important", pl:"40px !important", margin: '3px 12px !important' }} /> }
                                  
                                  <Stack
                                  onClick={handleClick}
                                  spacing={1}
                                  direction='row'
                                  alignItems='center'
                                  justifyContent='center'
                                  sx={{
                                    boxShadow: '0 0 3px 0 rgba(0,0,0,0.1)',
                                    width: '130px',
                                    height: '50px',
                                    borderRadius: '23px',
                                    cursor:"pointer",
                                    ml: loading ? '100px !important' : '0px',
                                    marginTop:'0px !important'
                                  }}
                                >
                                
                                  <Box sx={{ backgroundColor: colors.background.successBadge, width: '32px', height: '32px', borderRadius:"50%", display:"flex", justifyContent:"center", alignItems:"center" }}>
                                    <DollarSymbolIcon />
                                  </Box>
                                  <Typography variant='h5'>{currency}</Typography> 

                                  <Box color={colors.text.tertiary} mb={0.4} >
                                    <KeyboardArrowDownIcon />
                                  </Box>
                                </Stack>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={Boolean(anchorEl)}
                                  onClose={() => handleClose()}
                                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                  PaperProps={{
                                    sx: {
                                      minWidth: 130,
                                      borderRadius: '10px',
                                      boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                                      mt: 0.5,
                                      border: `0.5px solid ${colors.border.cardDiv}`,
                                    },
                                  }}
                                  MenuListProps={{
                                    disablePadding: true,
                                    sx: {
                                      '& .MuiMenuItem-root': {
                                        minHeight: 32,
                                        padding: '12px 20px',
                                        fontSize: 14,
                                        letterSpacing: "0.5px",
                                        lineHeight: "14px",
                                      },
                                    },
                                  }}
                                >
                                  <MenuItem sx={{ backgroundColor: currency === "SGD" ? colors.background.cardDivBg : 'transaparent' }} onClick={() => handleClose('SGD')}>SGD (default)</MenuItem>
                                  <MenuItem sx={{ backgroundColor: currency === "USD" ? colors.background.cardDivBg : 'transaparent' }} onClick={() => handleClose('USD')}>USD</MenuItem>
                                </Menu>
                                </Stack>
                                <Stack spacing={3} direction='row' alignItems='center' sx={{
                                  justifyContent: { xs: 'center', md: 'start' }, margin: '0 !important',
                                  '@media(max-width:1180px)': {
                                    justifyContent: "center"
                                  }
                                }} >

                                  {!loading ? <Stack direction='row' alignItems='center'>
                                    {returnAmount ? returnAmount?.toString()?.includes('-') ? currency == "USD" ? <Typography variant='h5' sx={{ color: colors.error.light, fontWeight: "550" }} >- $ {removeMinus(sgdToUsd(returnAmount, currentUSDPrice)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</Typography> : <Typography variant='h5' sx={{ color: colors.error.main, fontWeight: "550" }} >- $ {removeMinus(returnAmount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</Typography>
                                      : currency == "USD" ? <Typography variant='h5' sx={{ color: colors.success.main, fontWeight: "550" }} >+ $ {sgdToUsd(returnAmount, currentUSDPrice)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography> : <Typography variant='h5' sx={{ color: colors.success.main, fontWeight: "550" }} >+ $ {returnAmount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography> : '$ 0'
                                    }

                                  </Stack> : <BouncingDotsLoader sx={{ width: "10px !important", height: "10px !important", ml: '16px !important' }} />
                                  }

                                  {!loading ? <Stack direction='row' alignItems='center'>
                                    {metrics?.percentProfitLoss?.toString()?.includes('-') ? <ArrowDropDownIcon style={{ fontSize: '35px', color: colors.error.main }} />
                                      : <ArrowDropUpIcon style={{ fontSize: '35px', color: colors.success.main }} />
                                    }
                                    <Typography variant='h5' sx={{ color: metrics?.percentProfitLoss?.toString()?.includes('-') ? colors.error.main : colors.success.main, fontWeight: "550" }} > {metrics?.percentProfitLoss && `${metrics?.percentProfitLoss?.toString()?.includes('-') ? '' : '+'} ${parseFloat(metrics?.percentProfitLoss).toFixed(2)} %`}</Typography>
                                  </Stack> : <BouncingDotsLoader sx={{ width: "10px !important", height: "10px !important", ml: '16px !important' }} />
                                  }
                                  
                                </Stack>
                              </Stack>
                              
                          <Stack rowGap={2} columnGap={2} direction={{ lg: 'row', md: 'row', xs: 'row' }} alignItems='center' justifyContent='center' sx={{display:"flex", paddingTop:{ xs: '24px', md: "0px" },
                              '@media(max-width:1180px)': {
                                  flexDirection: 'row !important',
                                  paddingTop:"24px"
                              }
                          }} >
                              {/* <Button  sx={{display:{xs:"none",sm:"flex" }}} variant="contained">Add Deposit <IconButton sx={{ padding: "10px 0 12px 10px", width: '31px' }}> <AddButtonIcon /></IconButton></Button>
                              <Button  sx={{display:{xs:"none",sm:"flex"}}} variant="outlined">Withdraw <IconButton sx={{ padding: "10px 0 12px 10px", width: '31px' }}> <WithdrawIcon /></IconButton></Button> */}

                          <Button onClick={showBankDetails} endIcon={<MdAdd />} sx={{display:{xs:"none",sm:"flex",lg:"none" }, width:"140px"}} variant="contained">Add Deposit</Button>
                          <Button onClick={()=> handleContactUs('withdrawal')} endIcon={<FaMinus />} sx={{display:{xs:"none",sm:"flex",lg:"none"}, width:"140px"}} variant="outlined">Withdraw </Button>

                              <Box sx={{display:{xs:"flex",sm:"none" }, alignItems:"center", flexDirection:"column", gap:"10px"}}>
                                  <IconButton onClick={showBankDetails}><WithdrawMobileSvg /></IconButton>
                                  <Typography sx={{ fontWeight:"400", fontSize:"10.56px", lineHeight:"12.78px", color:colors.text.primary}}>Withdraw</Typography>
                              </Box>
                              <Box sx={{display:{xs:"flex",sm:"none" }, alignItems:"center", flexDirection:"column", gap:"10px"}}>
                                  <IconButton onClick={()=> handleContactUs('deposits')}><DepositMobileSvg /></IconButton>
                                  <Typography sx={{ fontWeight:"400", fontSize:"10.56px", lineHeight:"12.78px", color:colors.text.primary}}>Deposit</Typography>
                              </Box>

                          </Stack>
                      </Stack>
                      <Box sx={{display:"flex", maxWidth:"400px",  marginTop:"10px !important", margin: {xs: "0 auto", lg:'0'}, backgroundColor: colors.background.cardDivBg, flexDirection:"column", p:1, borderTopLeftRadius:"8px", borderTopRightRadius:"4px", borderBottomLeftRadius:"8px", borderBottomRightRadius:"8px"}}>
                        <Box sx={{display:"flex", gap:2, justifyContent:"space-between"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                        <Typography
                          sx={{
                            textAlign: { xs: 'center', md: 'start' },
                            // marginTop: { xs: '10px', sm: '10px' },
                            color:colors.text.primary, fontWeight:"500", fontSize:{xs:"12px",lg:"14px"}
                          }}
                        >
                          Base Capital (P&L):
                        </Typography>
                    <Tooltip
                      open={capitalToolTipOpen}
                      onOpen={() => setCapitalToolTipOpen(true)}
                      onClose={() => setCapitalToolTipOpen(false)}
                      disableTouchListener                 
                      title={<TooltipContent title={"Total Investment in Products"} description={"This figure represents the total capital you have allocated across all investment products within your portfolio."} />}
                      placement="right"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "white",
                            color: colors.text.secondary,
                            boxShadow: 1,
                            fontWeight: "400",
                            border: `1px solid ${colors.border.default}`,
                            borderRadius: "12px",
                            letterSpacing: "1%",
                            fontSize: "12px",
                          },
                        },
                      }}
                      PopperProps={{
                        modifiers: [
                          {
                            name: "offset",
                            options: { offset: [40, -10] },
                          },
                        ],
                      }}
                    >
                      <Box
                       onClick={() => {
                        // Toggle only on touch devices
                        if (window.matchMedia("(hover: none)").matches) {
                          setCapitalToolTipOpen((prev) => !prev);
                        }
                      }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          p: 1,
                        }}
                      >
                        <IdleCashToolTip style={{ cursor: "pointer", pointerEvents: "auto" }} />
                      </Box>
                    </Tooltip>
                        </Box>
      
                  {!loading ? <Typography
                    sx={{
                      textAlign: 'right',
                      marginTop: { xs: '10px', sm: '10px' },
                      color: colors.text.primary,
                      fontWeight: "500",
                      fontSize: { xs: "12px", lg: "14px" },
                    }}
                  >
                    $ {' '}
                    {metrics?.netInvestedValue
                      ? currency == "USD"
                        ? sgdToUsd(
                          parseFloat(metrics?.netInvestedValue),
                          currentUSDPrice?.toFixed(3)
                        )?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        : parseFloat(metrics?.netInvestedValue).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : 0} {' '}
                    <>
                      (<span
                        style={{
                          color: metrics?.percentProfitLoss?.toString()?.includes('-') ? colors.error.main : colors.success.main,
                          marginLeft: "4px",
                          fontWeight:"550"
                        }}>
                        {`${metrics?.percentProfitLoss?.toString()?.includes('-') ? "- " : "+ "}`} ${' '}
                        {profitLoseAmount
                          ? currency == "USD"
                            ? sgdToUsd(
                              parseFloat(profitLoseAmount),
                              currentUSDPrice?.toFixed(3)
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : parseFloat(profitLoseAmount).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : 0}
                      </span>{' '}
                      )
                    </>
                  </Typography> : 
                        <BouncingDotsLoader  sx={{width:"10px", height:"10px" }} />
                        }
                        </Box>
                      <Divider sx={{
                      border: 0,
                      borderBottom: `0.5px solid ${colors.border.grey}`,
                      opacity: 1,
                      mt: 1,
                      height:"0px",
                      backgroundColor: colors.border.cardDiv
                    }} />
                          <Box sx={{display:"flex", gap:2,justifyContent:"space-between"}}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        textAlign: { xs: 'center', md: 'start' },
                        // marginTop: { xs: '10px', sm: '10px' },
                        color: colors.text.primary, fontWeight: "500", fontSize: { xs: "12px", lg: "14px" }
                      }}
                    >
                      Idle Cash:
                    </Typography>
                    <Tooltip
                      open={idleCashToolTipOpen}
                      onOpen={() => setIdleCashToolTipOpen(true)}
                      onClose={() => setIdleCashToolTipOpen(false)}
                      disableTouchListener
                      title={<TooltipContent title={tooltipTextTitle} description={tooltipText} />}
                      placement="right"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "white",
                            color: colors.text.secondary,
                            boxShadow: 1,
                            fontWeight: "400",
                            border: `1px solid ${colors.border.default}`,
                            borderRadius: "12px",
                            letterSpacing: "1%",
                            fontSize: "12px",
                          },
                        },
                      }}
                      PopperProps={{
                        modifiers: [
                          {
                            name: "offset",
                            options: { offset: [40, -10] },
                          },
                        ],
                      }}
                    >
                      <Box
                        onClick={() => {
                          // Toggle only on touch devices
                          if (window.matchMedia("(hover: none)").matches) {
                            setIdleCashToolTipOpen((prev) => !prev);
                          }
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          p: 1,
                        }}
                      >
                        <IdleCashToolTip style={{ cursor: "pointer", pointerEvents: "auto" }} />
                      </Box>
                    </Tooltip>
                  </Box>
      
                        {!loading ? <Typography
                          sx={{
                            textAlign: 'right',
                            marginTop: { xs: '10px', sm: '10px' },
                            color:colors.text.primary, fontWeight:"500", fontSize:{xs:"12px",lg:"14px"},
                            fontWeight:"500"
                          }}
                        >
                          $ {metrics?.netInvestedValue ? currency == "USD" ? sgdToUsd(parseFloat(idleCash?.value), currentUSDPrice?.toFixed(3))?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : parseFloat(idleCash?.value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0} 
                        </Typography> : 
                        <BouncingDotsLoader  sx={{width:"10px", height:"10px" }} />
                        }
                        </Box>
                      </Box>
                      <Stack direction={{ xs: 'column', md: 'row' }} sx={{display:chartDatas?.length > 0 ? 'flex' : 'none'}} mt={1} justifyContent='space-between' alignItems='center' marginTop={{ xs: '40px', md: "0px" }} >
                          <Typography sx={{color:colors.neutral.outlinedText, fontWeight:"700", fontSize:{xs:"20px",md:"22px"}, lineHeight:"18.85px", letterSpacing:"2%"}} >Total Portfolio Overview</Typography>
                           <Box
  component='span'
  sx={{
    display: { xs: 'inline-block', sm: 'none' },
    alignItems: 'flex-start',
    width: 'fit-content',
    alignSelf: 'flex-end',
    mt: 4,
  }}
>
  <Stack
    direction='row'
    spacing={0.5}
    sx={{
      alignSelf: 'center',
      justifyContent: 'center',
      backgroundColor: colors.background.paper,
      boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
      borderRadius: '25px',
      padding: '4px',
    }}
  >
    <Button
      onClick={() => handleDuration('6 Months')}
      disableElevation
      sx={{
        minWidth: '70px',
        padding: '4px 10px',
        borderRadius: '20px',
        textTransform: 'none',
        fontSize: '13px',
        fontWeight: duration === '6 Months' ? 600 : 500,
        color: duration === '6 Months' ? colors.background.paper : colors.text.secondary,
        backgroundColor: duration === '6 Months' ? colors.primary.main : 'transparent',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: duration === '6 Months' ? colors.primary.main : 'transparent',
        },
      }}
    >
      6 Months
    </Button>
    <Button
      onClick={() => handleDuration('1 Year')}
      disableElevation
      sx={{
        minWidth: '70px',
        padding: '4px 10px',
        borderRadius: '20px',
        textTransform: 'none',
        fontSize: '13px',
        fontWeight: duration === '1 Year' ? 600 : 500,
        color: duration === '1 Year' ? colors.background.paper : colors.text.secondary,
        backgroundColor: duration === '1 Year' ? colors.primary.main : 'transparent',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: duration === '1 Year' ? colors.primary.main : 'transparent',
        },
      }}
    >
      1 Year
    </Button>
  </Stack>
</Box>
            <Box
              sx={{
                display: { xs: "none", sm: 'flex' },
                alignItems: 'flex-start',
                justifyContent: { xs: 'center' },
                marginTop: { xs: '19px', md: '0px' },
              }}
            >
              <Stack
                direction='row'
                spacing={0.5}
                sx={{
                  alignSelf: "center",
                  justifyContent: "center",
                  backgroundColor: colors.background.paper,
                   boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                  borderRadius: '30px',
                  padding: '5px',
                  // paddingTop: { xs: '0px', md: '5px' },
                  marginTop:{xs:"40px",sm:"20px"},
                  // '@media(max-width:990px)': {
                  //   paddingTop: "24px"
                  // }
                }}
              >
                <Button
                  onClick={() => handleDuration('6 Months')}
                  disableElevation
                  sx={{
                    minWidth: "85px",
                    borderRadius: '25px',
                    textTransform: 'none',
                    fontWeight: duration == '6 Months' ? 600 : 500,
                    color: duration == '6 Months' ? colors.background.paper : colors.text.secondary,
                    backgroundColor: duration == '6 Months' ? colors.primary.main : 'transparent',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: duration == '6 Months' ? colors.primary.main : 'transparent',
                    },
                  }}
                >
                  6 Months
                </Button>
                <Button
                  onClick={() => handleDuration('1 Year')}
                  disableElevation
                  sx={{
                    minWidth: "85px",
                    borderRadius: '25px',
                    textTransform: 'none',
                    fontWeight: duration == '1 Year' ? 600 : 500,
                    color: duration == '1 Year' ? colors.background.paper : colors.text.secondary,
                    backgroundColor: duration == '1 Year' ? colors.primary.main : 'transparent',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: duration == '1 Year' ? colors.primary.main : 'transparent',
                    },
                  }}
                >
                  1 Year
                </Button>
              </Stack>
            </Box>
                      </Stack>
                     {!loading ? <Box component='div' width='100%' height='100%' mt={3} className="apexcharts-xaxis-texts-g custom-xaxis-shift">
                          {graphData?.options?.chart ? <Chart options={graphData?.options} series={graphData?.series} type="area" width="100%" height='400px'  /> : 
                          <EmptyChart/>
                          }
                      </Box> : <Box sx={{width:"100%", height:"400px", display:"flex", justifyContent:"center", alignItems:"center"}}><CircularProgress disableShrink   /></Box>}
                    </>
                      {/* <Stack spacing={5} sx={{padding:"10px"}}>
                      <Skeleton variant="text"height={200} sx={{ fontSize: '1rem' }} />
                      <Skeleton variant="rectangular" sx={{ fontSize: '1rem' }} />
                      <Skeleton variant="rounded"  sx={{ fontSize: '1rem' }}  />
                      <Skeleton variant="rectangular" sx={{ fontSize: '1rem' }} />
                       <Skeleton variant="rounded"  sx={{ fontSize: '1rem' }}  />
                      <Skeleton variant="rectangular" sx={{ fontSize: '1rem' }} />
                      <Skeleton variant="rounded"  sx={{ fontSize: '1rem' }}  />
                    </Stack> */}
                  
                </Paper>

                {/* My Portfolio */}

                <Paper sx={{ backgroundColor: colors.primary.contrastText, marginTop: '40px', padding: {xs:"20px 10px",lg:'20px'}, borderRadius: '20px', height: 'auto',boxShadow: `0px 1px 5px 0px ${colors.border.card}`, }}>
                    <Stack direction={{ xs: 'column', md: "row" }} justifyContent='space-between' padding='10px 24px 20px 24px' sx={{ position: 'relative' }}>
                        <Typography sx={{color:colors.neutral.outlinedText, fontWeight:"550", fontSize:{xs:"19px", md:"21px"}, lineHeight:"35.74px"}} textAlign={{ xs: 'center', md: 'start' }}>My Products</Typography>
                        <Stack direction='row' justifyContent={{ xs: 'center', md: 'none' }} spacing={2} marginTop={{ xs: '35px', md: "0px" }}>
                            {/* <Button disabled={!onboardingStatusText} onClick={() => navigate('/Products')} variant="contained"> Add Product <IconButton sx={{ padding: "10px 0 12px 10px", width: '31px' }}> <MdAdd /></IconButton></Button> */}
                            <Button sx={{padding: "10px 0 12px 10px", width: '140px' }} disabled={!onboardingStatusText} endIcon={<MdAdd />} onClick={() => navigate('/Products')} variant="contained"> Add Product </Button>
                            {/* <Button sx={{padding: "10px 0 12px 10px", width: '140px' }} endIcon={<MdAdd />} onClick={() => navigate('/Products')} variant="contained"> Add Product </Button> */}
                        </Stack>
                        {/* <IconButton component='div' sx={{
                            position: 'absolute',
                            zIndex: '1',
                            bottom: '-40px',
                            right: '-10px',
                            width: '45px',
                            height: '45px',
                            backgroundColor: colors.primary.contrastText,
                            borderRadius: '100px',
                            display: { xs: 'flex', sm: 'none' },
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: '0 0 10px 0 rgba(0,0,0,0.2)',
                            color: colors.primary.main,
                            transition: '.3s',
                            marginBottom:"15px"
                        }}>
                            <ArrowForwardIosIcon sx={{
                                fontSize: '1.3rem'
                            }} />

                        </IconButton> */}
                    </Stack>

                    <Box component='div' mt={4} sx={{ paddingLeft: { xs: '0px', sm: '0px' } }}>
                        <TableContainer sx={{ backgroundColor: 'White_color', borderRadius: '10px', 
                          display:"none",
                           '@media(min-width:1025px)': {
                            display:"block"
                          }}}>
                            {!loading ? (
                            subscribedProducts?.length > 0 ? (
                              <Table aria-label="simple table">
                                <TableHead >
                                    <StyledTableRow sx={{ '.MuiTableCell-root': { color: colors.text.disabled, 

                                        borderBottom: `0.5px solid ${colors.border.cardDiv}`,
      verticalAlign: 'bottom',
      paddingBottom: '12px',
      paddingTop: '0px',
                                     } }}>
                                        <StyledTableCell sx={{fontSize:{xs:"13px !important", xl:"15px !important", textWrap:"wrap !important",color: `${colors.text.header} !important`}}}>NAME</StyledTableCell>
                                        <StyledTableCell sx={{textAlign:"right !important",fontSize:{xs:"13px  !important", xl:"15px !important", textWrap:"wrap !important",color: `${colors.text.header} !important`}}}>INVESTED AMOUNT</StyledTableCell>
                                        <StyledTableCell sx={{textAlign:"right !important",fontSize:{xs:"13px  !important", xl:"15px !important", textWrap:"wrap !important",color: `${colors.text.header} !important`}}}>ESTIMATED RETURNS</StyledTableCell>
                                        <StyledTableCell sx={{textAlign:"right !important",fontSize:{xs:"13px  !important", xl:"15px !important"}, textWrap:"wrap !important",color: `${colors.text.header} !important` }}>TENOR</StyledTableCell>
                                        <StyledTableCell sx={{textAlign:"right !important",fontSize:{xs:"13px  !important", xl:"15px !important"}, textWrap:"wrap !important",color: `${colors.text.header} !important` }}>PNL</StyledTableCell>
                                        <StyledTableCell sx={{textAlign:"right !important",fontSize:{xs:"13px  !important", xl:"15px !important"}, textWrap:"wrap !important",color: `${colors.text.header} !important`}}>ACTIONS</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                  <TableBody>
                                    {subscribedProducts?.map((itm) => (
                                        <StyledTableRow key={itm.id} >

                                            <StyledTableCell >
                                                {matches ? (<Tooltip title={itm?.name}><Box sx={{ display: 'flex', alignItems: 'center', }}>
                                                    <Box component='img' src={getIconUrl(itm?.iconUrl)} sx={{ width: {xs:"35px",lg:'43px'}, height: {xs:"35px",lg:'43px'}, marginRight:{xs:"5px",lg:"10,4px"} }}></Box>
                                                   <Typography sx={{fontWeight:"700", fontSize:{xs:"13px",lg:"14.68px"}, lineHeight:"18.46px", letterSpacing:"5%", maxWidth:{xs:"100px", lg:"unset"}, overflow:"hidden", textOverflow:"ellipsis"}}>{itm?.name}</Typography>
                                                </Box></Tooltip>) : (
                                                  <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                                  <Box component='img' src={getIconUrl(itm?.iconUrl)} sx={{ width: {xs:"35px",lg:'43px'}, height: {xs:"35px",lg:'43px'}, marginRight:{xs:"5px",lg:"10,4px"} }}></Box>
                                                 <Typography sx={{fontWeight:"700", fontSize:{xs:"13px",lg:"14.68px"}, lineHeight:"18.46px", letterSpacing:"5%", maxWidth:{xs:"100px", lg:"unset"}, overflow:"hidden", textOverflow:"ellipsis"}}>{itm?.name}</Typography>
                                              </Box>
                                                )}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{fontWeight:"600 !important", textAlign:"right !important", width:"200px !important", color:colors.text.primary,fontSize:{xs:"13px !important", xl:"15px !important"}}}>$ {itm?.metrics?.netInvestedValue ? currency == "USD" ? sgdToUsd(parseFloat(itm?.metrics?.netInvestedValue), currentUSDPrice).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) :parseFloat(itm?.metrics?.netInvestedValue)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}</StyledTableCell>
                                            <StyledTableCell sx={{fontWeight:"600 !important", textAlign:"right !important", width:"200px !important", color: colors.text.primary,  fontSize:{xs:"13px !important", xl:"15px !important"} }}>$ {itm?.estimatedReturn ? currency == "USD" ? sgdToUsd(parseFloat(itm?.estimatedReturn), currentUSDPrice).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : parseFloat(itm?.estimatedReturn)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}</StyledTableCell>
                                            <StyledTableCell sx={{fontWeight:"600 !important",textAlign:"right !important", width:"200px !important",color:colors.text.primary,fontSize:{xs:"13px !important", xl:"15px !important"}}}>{itm?.tenor > 1000000 ? <Box component={'img'} src={InfiniteIcon} sx={{height:"15px",width:"30px",fontSize:{xs:"13px !important", xl:"15px !important"}}}/> : `${itm?.tenor} months` }</StyledTableCell>
                                            <StyledTableCell sx={{fontWeight:"600 !important",textAlign:"right !important", width:"200px !important",color:colors.text.primary}}>  <>
                                              { itm?.metrics?.percentProfitLoss?.toString()?.includes('-') ? <Typography variant='h5' sx={{ color: colors.error.light,fontSize:{xs:"13px !important", xl:"15px !important"} }} >- { itm?.metrics?.percentProfitLoss ? parseFloat(removeMinus(itm?.metrics?.percentProfitLoss))?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0} %</Typography>
                                              :<Typography variant='h5' sx={{ color: colors.secondary.main,fontSize:{xs:"13px !important", xl:"15px !important"} }} >+ { itm?.metrics?.percentProfitLoss ? parseFloat(itm?.metrics?.percentProfitLoss)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0} %</Typography>
                                              } </>
                                            </StyledTableCell>
                                            <StyledTableCell sx={{textAlign:"right !important",width:"200px !important",}}>
                                                <IconButton onClick={(event) => handleClickMore(event, itm.id)}>
                                                    <DotsIcon />
                                                </IconButton>
                                          <Menu
                                            anchorEl={productEl}
                                            open={Boolean(productEl)}
                                            onClose={handleProductMenuClose}
                                            sx={{ display: { xs: "block", sm: "none" } }}
                                            PaperProps={{
                                              elevation: 0,
                                              sx: {
                                                boxShadow: ` 0px 0px 1px 0px ${colors.border.card}`,
                                                borderRadius: '10px',
                                                border: `1px solid ${colors.background.cardDivBg}`,
                                              },
                                            }}
                                          >
                                                    <MenuItem sx={{padding:"8px 12px 8px 12px", fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} onClick={handleViewProduct}>View Product</MenuItem>
                                                    <MenuItem sx={{padding:"8px 12px 8px 12px", fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} disabled >Update Product</MenuItem>                                                    
                                                    <MenuItem sx={{padding:"8px 12px 8px 12px", fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} disabled >Unsubscribe</MenuItem>
                                                    <MenuItem sx={{padding:"8px 12px 8px 12px", fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} disabled >Top-Up</MenuItem>
                                                </Menu>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>):(
                               <Box 
                               sx={{ 
                                 display: "flex", 
                                 justifyContent: "center", 
                                 alignItems: "center", 
                                 height: "100%" ,
                                 minHeight:"200px"
                               }}>
                               <Typography
                                 sx={{
                                   textAlign: 'center',
                                   mb: { xs: 2, lg: 0 },
                                   color: colors.text.tertiary,
                                   fontWeight: "500",
                                   fontSize: { xs: "18px", lg: "18px" }
                                 }}
                               >
                                 No Subscribed Products
                               </Typography>
                             </Box>
                            )
                          ): (
                            <Table>
                            <TableBody>
                            {Array.from(new Array(5)).map((_, rowIndex) => (
                              <StyledTableRow key={rowIndex}>
                                {Array.from(new Array(3)).map((_, colIndex) => (
                                  <StyledTableCell key={colIndex}>
                                     <ShimmerSkeleton variant="rectangular" width="100%" height={40} />
                                  </StyledTableCell>
                                ))}
                              </StyledTableRow>
                            ))}
                          </TableBody>
                          </Table>
                          )}
                        </TableContainer>
                        <Box sx={{
                           display:"none",
                           '@media(max-width:1024px)': {
                            display:"flex"
                          },
                          flexDirection:"column", gap:"10px"}}>
                        {!loading ? (
                        subscribedProducts?.length > 0 ? (
                        subscribedProducts?.map((itm,index) => (
                          <Accordion 
                            key={index}
                            expanded={expanded === index}
                            onChange={handleChange(index)}
                            >
                          <AccordionSummary
                          sx={{backgroundColor:colors.background.default}}
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                <Box component='img' src={getIconUrl(itm?.iconUrl)} sx={{ width: '43px', height: '43px', marginRight:{xs:"5px",lg:"10,4px"} }}></Box>
                                <Typography sx={{fontWeight:"700", fontSize:{xs:"13px",lg:"14.68px"}, lineHeight:"18.46px", letterSpacing:"5%"}}>{itm?.name}</Typography>
                            </Box>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box sx={{display:"flex", flexDirection:"column", gap:"20px"}}>
                              <Box sx={{display:"flex", justifyContent:"space-between"}}>
                                <Typography sx={{fontWeight:"400", fontSize:"12px"}}>INVESTED AMOUNT</Typography>
                                <Typography sx={{fontWeight:"400", fontSize:"12px"}}>$ {itm?.metrics?.netInvestedValue ? currency == "USD" ? sgdToUsd(parseFloat(itm?.metrics?.netInvestedValue), currentUSDPrice).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : parseFloat(itm?.metrics?.netInvestedValue)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}</Typography>
                              </Box>
                              <Box sx={{display:"flex", justifyContent:"space-between"}}>
                                <Typography sx={{fontWeight:"400", fontSize:"13px"}}>ESTIMATED RETURNS</Typography>
                                <Typography sx={{fontWeight:"400", fontSize:"13px"}}>$ {itm?.estimatedReturn ? currency == "USD" ? sgdToUsd(parseFloat(itm?.estimatedReturn), currentUSDPrice).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : parseFloat(itm?.estimatedReturn)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}</Typography>
                              </Box>
                              <Box sx={{display:"flex", justifyContent:"space-between"}}>
                                <Typography sx={{fontWeight:"400", fontSize:"13px"}}>TENOR</Typography>
                                <Typography sx={{fontWeight:"400", fontSize:"13px"}}>{itm?.tenor > 1000000 ? <Box component={'img'} src={InfiniteIcon} sx={{height:"15px",width:"30px",fontSize:{xs:"13px !important", xl:"15px !important"}}}/> : `${itm?.tenor} months` }</Typography>
                              </Box>
                              <Box sx={{display:"flex", justifyContent:"space-between"}}>
                                <Typography sx={{fontWeight:"400", fontSize:"13px"}}>PNL</Typography>
                                <Box>
                                  {/* { itm?.metrics?.percentProfitLoss?.toString()?.includes('-') ? <Typography variant='h5' sx={{ color: colors.error.light,fontSize:{xs:"13px !important", xl:"15px !important"} }} >- {itm?.metrics?.percentProfitLoss?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%</Typography>
                                  :<Typography variant='h5' sx={{ color: colors.secondary.main,fontSize:{xs:"13px !important", xl:"15px !important"} }} >+ {itm?.metrics?.percentProfitLoss?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%</Typography>
                                  }  */}
                                  { itm?.metrics?.percentProfitLoss?.toString()?.includes('-') ? <Typography variant='h5' sx={{ color: colors.error.light,fontSize:{xs:"13px !important", xl:"15px !important"} }} >- { itm?.metrics?.percentProfitLoss ? parseFloat(itm?.metrics?.percentProfitLoss)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}%</Typography>
                                  :<Typography variant='h5' sx={{ color: colors.secondary.main,fontSize:{xs:"13px !important", xl:"15px !important"} }} >+ { itm?.metrics?.percentProfitLoss ? parseFloat(itm?.metrics?.percentProfitLoss)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0}%</Typography>
                                  }
                                </Box>
                              </Box>
                              <Box sx={{display:"flex", justifyContent:"space-between"}}>
                                <Typography sx={{fontWeight:"400", fontSize:"13px"}}>ACTIONS</Typography>
                                <Box>
                                  <IconButton onClick={(event) => handleClickMore(event, itm.id)}>
                                        <DotsIcon />
                                  </IconButton>
                                  <Menu
                                      anchorEl={productEl}
                                      open={Boolean(productEl)}
                                      onClose={handleProductMenuClose}
                                      sx={{display:{xs:"none", sm:"block"}}}
                                      PaperProps={{
                                        elevation: 0,
                                        sx: {
                                          boxShadow: ` 0px 0px 1px 0px ${colors.border.card}`,
                                          borderRadius: '10px',
                                          border: `1px solid ${colors.background.cardDivBg}`,
                                        },
                                      }}
                                  >
                                    <MenuItem sx={{padding:"8px 12px 8px 12px",fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} onClick={handleViewProduct}>View Product</MenuItem>
                                    <MenuItem sx={{padding:"8px 12px 8px 12px",fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} disabled>Update Product</MenuItem>                                                    
                                    <MenuItem sx={{padding:"8px 12px 8px 12px",fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} disabled>Unsubscribe</MenuItem>
                                    <MenuItem sx={{padding:"8px 12px 8px 12px",fontSize:"14px", color:colors.text.primary, lineHeight:"15.08px", letterSpacing:"2%", fontWeight:"500", mb:0.5}} disabled>Top-Up</MenuItem>
                                  </Menu>
                                </Box>
                              </Box>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                        ))
                        ): (
                          <Box 
                               sx={{ 
                                 display: "flex", 
                                 justifyContent: "center", 
                                 alignItems: "center", 
                                 minHeight:"200px"
                               }}>
                               <Typography
                                 sx={{
                                   textAlign: 'center',
                                   mb: { xs: 2, lg: 0 },
                                   color: colors.text.tertiary,
                                   fontWeight: "500",
                                   fontSize: { xs: "18px", lg: "18px" }
                                 }}
                               >
                                 No Subscribed Products
                               </Typography>
                             </Box>
                        )) : (
                            <TableBody>
                            {Array.from(new Array(5)).map((_, rowIndex) => (
                              <StyledTableRow key={rowIndex}>
                                {Array.from(new Array(3)).map((_, colIndex) => (
                                  <StyledTableCell key={colIndex}>
                                    <Skeleton variant="rectangular" width="100%" height={40} />
                                  </StyledTableCell>
                                ))}
                              </StyledTableRow>
                            ))}
                          </TableBody>
                        )
                        }
                        </Box>
                      
                    </Box>
                </Paper>
            </MainLayout >
        </>
    )
}
